import { useMemo, useState } from 'react'
import PatrimoniosHttp from '../../../../services/api/https/patrimonio/patrimonio.http'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_DATA: 'Adquirindo dados',
}

const INITIAL_STATE = {
  saldos: [],
  saldosOriginal: [],
  selectedDono: null,
  donos: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useSaldoPatrimonialPorOperacao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getReportData(selectedTp) {
        let tpsIds = []
        if (selectedTp === 0) {
          tpsIds.push(
            ...getTps()
              .filter(tp => tp.id !== 0)
              .map(tp => tp.id),
          )
        } else {
          tpsIds.push(selectedTp)
        }
        PatrimoniosHttp.fetchSaldoPatrimonial(tpsIds)
          .then(data => {
            setState(prevState => ({
              ...prevState,
              saldos: data,
              saldosOriginal: data,
              donos: Array.from(new Set(data.map(d => d.dono_patrimonio))).map(dono => ({
                name: dono,
                value: dono,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_DATA }))
      },

      onChageDono(selectedDono) {
        setState(prevState => {
          prevState.selectedDono = selectedDono
          if (selectedDono) {
            prevState.saldos = prevState.saldosOriginal.filter(
              s => s.dono_patrimonio === selectedDono.value,
            )
          } else {
            prevState.saldos = prevState.saldosOriginal
          }
          return { ...prevState }
        })
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      async onBtnExportarExcel(saldos) {
        const colunas = [
          ['Op. Logístico', 'Dono', 'Patrimonio', 'Qte. Fisico', 'Qte. Em Transito', 'Qte. Total'],
        ]

        saldos.forEach(p => {
          colunas.push([
            p.tp_name,
            p.dono_patrimonio,
            p.patrimonio_ativo_name,
            p.total_fisico,
            p.total_em_transito,
            p.total,
          ])
        })

        gerarArquivoExcel(
          'saldos',
          colunas,
          `SaldoPatrimonialPorOperacao${new Date().toLocaleString().slice(0, 10)}.xlsx`,
        )
      },
    }
  }, [])

  return { state, localDispatch }
}
